import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { FolderTree, List } from 'lucide-react';
import { FormattedMessage } from 'react-intl';

export type ViewMode = 'table' | 'tree';

interface ViewSwitcherProps {
    viewMode: ViewMode;
    onViewModeChange: (mode: ViewMode) => void;
}

export default function ViewSwitcher({
    viewMode,
    onViewModeChange,
}: ViewSwitcherProps) {
    const handleChange = (
        _: React.MouseEvent<HTMLElement>,
        newViewMode: ViewMode | null
    ) => {
        if (newViewMode !== null) {
            onViewModeChange(newViewMode);
        }
    };

    return (
        <ToggleButtonGroup
            value={viewMode}
            exclusive
            onChange={handleChange}
            size="small"
        >
            <ToggleButton
                value="tree"
                aria-label="tree view"
                sx={{ display: 'flex', gap: 1, alignItems: 'center' }}
            >
                <FolderTree size={16} />
                <FormattedMessage id="treeView" defaultMessage="Tree" />
            </ToggleButton>
            <ToggleButton
                value="table"
                aria-label="table view"
                sx={{ display: 'flex', gap: 1, alignItems: 'center' }}
            >
                <List size={16} />
                <FormattedMessage id="listView" defaultMessage="List" />
            </ToggleButton>
        </ToggleButtonGroup>
    );
}
